module.exports = "/assets/81bf4227472b0244b94f0742f37f3d63.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/supplier/assets/logos/unknown-icon.png
// module id = 616
// module chunks = 0